<form [formGroup]="acceptForm" (ngSubmit)="submit()">
  <div class="partner-form-title d-flex align-items-center w-100">
    <span class="text-center mb-0 font-size-14 font-sans-bold">{{ 'partner.accept.form.title' | translate }}</span>
  </div>
  <div class="accept-form-container">
    <label class="font-size-14 accept-description">{{ 'accept.partner.description' | translate }}</label>

    <div class="accept-form-content">
      <div class="form-floating w-100">
        <input
          formControlName="code"
          placeholder="Insert code here"
          class="custom-field-form form-control field"
          id="customField"
        />
        <label class="display-name-custom-field font-size-10" for="floatingInputCustomField">{{
          'partner.add.form.code.label' | translate
        }}</label>
      </div>
      <div class="form-floating w-100">
        <input
          formControlName="secretCode"
          placeholder="Insert code here"
          type="email"
          class="custom-field-form form-control field"
          id="customField"
        />
        <label class="display-name-custom-field font-size-10" for="floatingInputCustomField">{{
          'partner.accept.form.secretcode.label' | translate
        }}</label>
      </div>
    </div>
    <div class="mt-2 error-message">
      <fgbcl-errors></fgbcl-errors>
    </div>
  </div>

  <div class="button-container d-flex justify-content-end form-buttons w-100">
    <button (click)="close(); $event.preventDefault()" class="btn btn-danger fw-bold ms-3">
      {{ 'partner.add.form.cancel.button' | translate }}
    </button>
    <button type="submit" [disabled]="acceptForm.invalid" class="btn btn-success fw-bold me-3">
      {{ 'partner.form.accept.button' | translate }}
    </button>
  </div>
</form>
